export default "__VITE_ASSET__lTASBxEb__"